export default __webpack_public_path__ + "static/media/logo.e158ed35.png";